import { useState } from "react";
import { Ad } from "@models/Ad.model";
import AdCard from "@/shared/components/AdCard";
import { groupChildren } from "./groupChildren";

interface ContainerPreviewTabsProps {
  children: Ad[];
}

export default function ContainerPreviewTabs({ children }: ContainerPreviewTabsProps) {
  const groups = groupChildren(children);
  const [activeKey, setActiveKey] = useState<string | null>(groups[0]?.key ?? null);

  if (groups.length === 0) {
    return <div className="mt-page__empty">No child ads in this container.</div>;
  }

  const activeGroup = groups.find((g) => g.key === activeKey) ?? groups[0];

  return (
    <div className="mt-preview-tabs">
      <div className="mt-preview-tabs__tabs" role="tablist">
        {groups.map((g) => (
          <button
            key={g.key}
            role="tab"
            aria-selected={g.key === activeGroup.key}
            className={`mt-preview-tabs__tab${g.key === activeGroup.key ? " mt-preview-tabs__tab--active" : ""}`}
            onClick={() => setActiveKey(g.key)}
          >
            {g.label} ({g.ads.length})
          </button>
        ))}
      </div>
      <div className="mt-preview-tabs__grid">
        {activeGroup.ads.map((ad) => (
          <AdCard key={ad.id} ad={ad} mode="detail" menuActions={[]} />
        ))}
      </div>
    </div>
  );
}
